module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/home-garden-84223a900dfaaa8f0d1d6bc065100bf0.png";